import { NavLink } from 'react-router-dom';
import { Home, Wrench, Newspaper, AlertTriangle, User, Shield } from 'lucide-react';
import './BottomNav.css';

interface BottomNavProps {
    isAdmin?: boolean;
}

const items = [
    { to: '/dashboard', label: 'Home', icon: Home },
    { to: '/providers', label: 'Pros', icon: Wrench },
    { to: '/news', label: 'News', icon: Newspaper },
    { to: '/report', label: 'Report', icon: AlertTriangle },
    { to: '/profile', label: 'Profile', icon: User },
];

export function BottomNav({ isAdmin = false }: BottomNavProps) {
    return (
        <nav className={`bottom-nav ${isAdmin ? 'bottom-nav--admin' : ''}`} aria-label="Main">
            {items.map(({ to, label, icon: Icon }) => (
                <NavLink
                    key={to}
                    to={to}
                    className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}
                >
                    <Icon size={24} aria-hidden="true" />
                    <span>{label}</span>
                </NavLink>
            ))}

            {isAdmin && (
                <NavLink
                    to="/admin"
                    className={({ isActive }) => `bottom-nav-item bottom-nav-item--admin ${isActive ? 'active' : ''}`}
                >
                    <Shield size={24} aria-hidden="true" />
                    <span>Admin</span>
                </NavLink>
            )}
        </nav>
    );
}
